import {HandleSubmit} from '../../func/HandleSubmit';

async function DeleteKala(kala_code) {
    console.log("url: ", kala_code);
    const SendParameters= {
        object: "kala",
        detail: {
            kala_code: kala_code,
        }
    };
        var response_info = await HandleSubmit('kala/delete', SendParameters);
        if (response_info.status.trim() === "OK") {
            alert("حذف گردید");
        }
        else {
            alert("مشکل در حذف");
        }
    }
export default (DeleteKala);




// WEBPACK FOOTER //
// ./src/pages/Kala/DeleteKala.js